export const PARTNER_AND_CUSTOMER = "PARTNER_AND_CUSTOMER";
export const PARTNER = "PARTNER";
export const CUSTOMER = "CUSTOMER";
export const USER = "USER";
